import { render, staticRenderFns } from "./AlerteFacture.vue?vue&type=template&id=24083c9d"
import script from "./AlerteFacture.vue?vue&type=script&lang=js"
export * from "./AlerteFacture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports